import {type FunctionalComponent, h} from '@stencil/core';
import countryname from '../../../../../helpers/countryname';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';


export interface OnlyYourCountryApc {
    appName: string;
    isCountryOnly:boolean;
    handleChange: CallableFunction;
    labelProvider: labelProviderInterface
    country: string
    language: string
}

export const OnlyYourCountryApc: FunctionalComponent<OnlyYourCountryApc> = (props) => {

    const {appName, country, language, isCountryOnly, labelProvider, handleChange } = props;

    return ( appName == 'products-apc' ? (
      <div
        slot="end"
        class="only-your-country"
      >
        <qds-checkbox
          checked={
            isCountryOnly
          }
          size={'small'}
          class="search-tab__country-results-input"
          id="countryResultsOnly"
          onQdsChange={(event) =>
            handleChange(event)
          }
          Text={labelProvider(
            `result.only-your-country-${country}-${language}`,
            `Show results for ${countryname(
              country,
              language
            )} only`
          )}
        ></qds-checkbox>
      </div>
    ) : (''

    ));
};
